import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
const ColumnToolTipHeader = ({ columnName, tooltipTitle })=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            columnName,
            /*#__PURE__*/ _jsx(Tooltip, {
                title: tooltipTitle,
                children: /*#__PURE__*/ _jsx(QuestionCircleOutlined, {
                    style: {
                        marginLeft: "5px"
                    }
                })
            })
        ]
    });
};
export { ColumnToolTipHeader };
